require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./listdropdown"), require("./tags"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./listdropdown", "./tags"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./listdropdown"), require("./tags")) : factory(root["./utils"], root["./listdropdown"], root["./tags"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__36__, __WEBPACK_EXTERNAL_MODULE__51__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[60],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-tagInput{display:inline-block;width:100%;-ms-overflow-style:none}.ba-common-tagInput .tag-input{background-color:rgba(0,0,0,.05);border:0;border-bottom-width:2px;border-bottom-style:solid;position:relative}.ba-common-tagInput.is-disabled>.ba-common-tagInput.is-disabled__input{cursor:not-allowed}.ba-common-tagInput.is-disabled *{cursor:not-allowed}.ba-common-tagInput.is-tagsSelected .ba-common-tagInput__input{margin-left:0}.ba-common-tagInput.is-focusedInput .ba-common-tagInput__input::-ms-clear{display:none}.ba-common-tagInput .ba-common-tags{min-height:32px;max-height:96px;overflow-y:auto;padding:4px 16px 4px 16px}.ba-common-tagInput__input{width:100px;flex-grow:1;border:0;outline:none;font-family:inherit;font-size:.875rem;background-color:transparent;position:relative;margin:2px 0;padding:4px;display:inline-block;line-height:21px}.ba-common-tagInput__input:active{cursor:none}.ba-common-tagInput__placeholder{width:max-content;opacity:.6}.ba-common-tagInput__line{position:absolute;display:block;width:100%;transform:scaleX(0);border-width:0;border-bottom-width:2px;border-style:solid;bottom:-2px;margin:0}.ba-common-tagInput__icon{position:absolute;line-height:0;pointer-events:none;z-index:1}.ba-common-tagInput__icon.is-left{top:20px;left:16px;transform:translateX(-50%) translateY(-50%)}.ba-common-tagInput__icon.is-right{bottom:0;right:16px;transform:translateX(50%) translateY(-50%)}.ba-common-tagInput .more-info{position:absolute;top:-24px;right:1px;font-size:.75rem;font-weight:600;visibility:hidden;cursor:pointer}.ba-common-tagInput .success-message{visibility:hidden;font-size:.75rem;font-weight:600;margin-top:8px;color:#24a148;color:hsla(var(--support-02-h, 137.28), var(--support-02-s, 63.4517766497%), var(--support-02-l, 38.6274509804%), 1);position:relative}.ba-common-tagInput .validation-error{visibility:hidden;font-size:.75rem;font-weight:600;margin-top:8px;color:#da1e28;color:hsla(var(--support-01-h, 356.8085106383), var(--support-01-s, 75.8064516129%), var(--support-01-l, 48.6274509804%), 1);position:relative}.ba-common-tagInput .is-validation{visibility:visible}.ba-common-tagInput .is-moreInfo{visibility:visible}.ba--highContrast .ba-common-tagInput.is-disabled{cursor:not-allowed}.ba--highContrast .ba-common-tagInput.is-disabled:after{content:\"\";position:absolute;top:50%;left:0;width:100%;border-bottom:1px solid currentColor}.ba-common-tagInput{transition:opacity .2s ease-in-out;transition:color .2s ease-in-out,border-color .2s ease-in-out;color:#343334;border-color:#595859}.ba-common-tagInput.is-error .tag-input{border-color:#da1e28;border-color:hsla(var(--support-01-h, 356.8085106383), var(--support-01-s, 75.8064516129%), var(--support-01-l, 48.6274509804%), 1)}.ba-common-tagInput.is-error .validation-error{visibility:visible}.ba-common-tagInput.is-success .tag-input{border-color:#00aa5e;border-color:hsla(var(--communication1-h, 153.1764705882), var(--communication1-s, 100%), var(--communication1-l, 33.3333333333%), 1)}.ba-common-tagInput.is-success .success-message{visibility:visible}.ba-common-tagInput::placeholder{transition:color .2s ease-in-out;color:#595859}.ba-common-tagInput__line{transition:transform .2s ease-in-out;border-color:#0f62fe;border-color:hsla(var(--interactive-01-h, 219.1631799163), var(--interactive-01-s, 99.1701244813%), var(--interactive-01-l, 52.7450980392%), 1)}.ba-common-tagInput__createNewTagItem{color:#0f62fe;color:hsla(var(--interactive-01-h, 219.1631799163), var(--interactive-01-s, 99.1701244813%), var(--interactive-01-l, 52.7450980392%), 1)}.ba-common-tagInput.is-open .ba-common-tagInput__icon,.ba-common-tagInput.is-focusedInput .ba-common-tagInput__icon{color:#0f62fe;color:hsla(var(--interactive-01-h, 219.1631799163), var(--interactive-01-s, 99.1701244813%), var(--interactive-01-l, 52.7450980392%), 1)}.ba-common-tagInput.is-open .ba-common-tagInput__line,.ba-common-tagInput.is-focusedInput .ba-common-tagInput__line{transform:scaleX(1)}.ba-common-tagInput__icon{transition:color .2s ease-in-out;color:#595859}.ba-common-tagInput.is-disabled .tag-input{opacity:.5}.ba-common-tagInput.is-focus{box-shadow:0px 0px 0px 2px #a8c0f3;box-shadow:0px 0px 0px 2px var(--focus, #a8c0f3)}.ba-common-tagInput.is-focus>.ba-common-tagInput__input:focus:enabled~.ba-common-tagInput__line{border-color:#595859}.ba-common-tagInput .more-info{color:#0f62fe;color:hsla(var(--interactive-01-h, 219.1631799163), var(--interactive-01-s, 99.1701244813%), var(--interactive-01-l, 52.7450980392%), 1)}.ba-common-tagInput.is-disabled .ba-common-button{opacity:1}.ba-common-tagInput.is-disabled .ba-common-button .ba-common-button__layout{opacity:.5}", ""]);

// exports
exports.locals = {
	"tagInputClassName": "\"ba-common-tagInput\""
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__36__;

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/close_32");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__51__;

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(522);


/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _TagInput = _interopRequireDefault(__webpack_require__(523));

exports.default = _TagInput.default;
exports.TagInput = _TagInput.default;

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _tags = _interopRequireDefault(__webpack_require__(51));

var _listdropdown = _interopRequireDefault(__webpack_require__(36));

var _close_ = _interopRequireDefault(__webpack_require__(39));

var _TagInput = _interopRequireDefault(__webpack_require__(524));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  BaPropTypes
} = _utils.propsUtils;
const {
  containsFilter
} = _utils.arrayFilters;
const {
  getKeyName,
  keyNames
} = _utils.keyboardUtils;
const {
  sanitize,
  getInheritedProps
} = _utils.propsUtils;
const {
  get,
  uniqueId
} = _utils.lodash;

const tagInputClassName = _TagInput.default.tagInputClassName.replace(/"/g, '');

function filterTags(options, selectedTags) {
  return options.filter(option => selectedTags.every(tag => tag.value !== option.value));
}
/* eslint no-underscore-dangle: 'off' */


class TagInput extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_onClose", () => {
      this.setState({
        open: false
      });
    });
    (0, _defineProperty2.default)(this, "_onInputValChange", e => {
      const {
        onChange
      } = this.props;
      const {
        value
      } = e.target;
      const handled = onChange && onChange(value, e);

      if (!handled) {
        this._updateState(false, value);
      }
    });
    (0, _defineProperty2.default)(this, "_updateState", (propsUpdated, newInputText) => {
      const newState = {};

      if (propsUpdated) {
        newState.selectedTags = this.props.selectedTags;
        newState.tagOptions = this.props.tagOptions;
        newState.availTags = typeof this.props.selectedTags !== 'undefined' ? filterTags(this.props.tagOptions, this.props.selectedTags) : this.props.tagOptions;
        newState.focusedInput = true;
      }

      const {
        open
      } = this.state;
      const inputText = newInputText !== undefined ? newInputText : this.inputNode.value;
      const {
        tagOptions,
        selectedTags,
        customFilter,
        customOpenStateController
      } = this.props;

      const freshOptionSet = this._refreshOptions(tagOptions, selectedTags);

      const searchResult = customFilter ? customFilter({
        value: inputText,
        values: freshOptionSet
      }) : freshOptionSet.filter(containsFilter(inputText));

      if (customOpenStateController) {
        const customOpen = customOpenStateController({
          value: inputText
        });

        if (customOpen !== open) {
          newState.open = customOpen;
        }

        if (customOpen) {
          newState.availTags = searchResult;
        }
      } else if (!inputText || searchResult.length < 1) {
        if (open) {
          newState.open = false;
        }
      } else if (searchResult.length > 0) {
        newState.availTags = searchResult;

        if (!open) {
          newState.open = true;
        }
      }

      newState.savedLabel = inputText;
      if (Object.entries(newState).length > 0) this.setState(newState);
    });
    (0, _defineProperty2.default)(this, "_onInputKeyDown", e => {
      switch (getKeyName(e)) {
        case keyNames.UP:
        case keyNames.DOWN:
        case keyNames.ENTER:
          e.preventDefault();
          this._dropdown && this._dropdown._list && this._dropdown._list.handleKeyEvent(e);

          if (!this.state.open) {
            const {
              customOpenStateController
            } = this.props;
            const nextOpen = customOpenStateController ? customOpenStateController({
              event: e,
              value: this.inputNode.value
            }) : true;

            if (nextOpen) {
              this.setState({
                availTags: filterTags(this.props.tagOptions, this.props.selectedTags),
                open: true
              });
            }
          }

          break;

        case keyNames.ESCAPE:
          this._close();

          break;

        case keyNames.BACKSPACE:
          if (e.target.value === '') {
            const {
              onTagRemoved,
              onTagsChanged
            } = this.props;
            const backspaceDelTag = this.state.selectedTags.pop();
            this.setState(state => ({
              selectedTags: state.selectedTags
            }));
            onTagRemoved && onTagRemoved(backspaceDelTag);
            onTagsChanged && onTagsChanged(this.state.selectedTags);
          }

          break;

        default:
          break;
      }
    });
    (0, _defineProperty2.default)(this, "_onBlur", e => {
      const listNode = get(this, '_dropdown._list._node');
      const dropdownWrapper = get(this, '_dropdown._wrapper');

      if (listNode && (listNode.contains(document.activeElement) || listNode.contains(e.relatedTarget)) || dropdownWrapper && dropdownWrapper.contains(document.activeElement) || e.target !== e.currentTarget) {
        this.focus();
      } else {
        this.blur();
        this.setState({
          focusedInput: false,
          open: false
        });
      }
    });
    (0, _defineProperty2.default)(this, "_onFocus", () => {
      this.focus();

      this._setInputFocused();
    });
    (0, _defineProperty2.default)(this, "_dropdownOnActiveChange", focusIndex => {
      this.setState({
        focusIndex
      });
    });
    (0, _defineProperty2.default)(this, "_setInputFocused", () => {
      this.setState({
        focusedInput: true
      });
    });
    (0, _defineProperty2.default)(this, "_close", () => {
      if (this.state.open) this.setState({
        open: false
      });
    });
    (0, _defineProperty2.default)(this, "_onTagSelect", (value, name, index) => {
      if (this.state.open) {
        const {
          selectionCap,
          onTagAdded,
          onTagsChanged
        } = this.props;
        const {
          availTags,
          selectedTags
        } = this.state;

        if (selectionCap && selectedTags.length >= selectionCap.number) {
          selectionCap.onWarning();
        } else {
          const newSelectedTags = this.state.selectedTags.concat([availTags[index]]);
          this.setState(state => ({
            selectedTags: newSelectedTags,
            availTags: filterTags(state.tagOptions, selectedTags),
            open: false,
            focusedInput: true,
            savedLabel: ''
          }));
          onTagAdded && onTagAdded(availTags[index]);
          onTagsChanged && onTagsChanged(newSelectedTags);
          this.inputNode.value = '';
        }
      }
    });
    (0, _defineProperty2.default)(this, "_editLabel", tag => {
      if (!this.props.disabled) {
        // delete the tag
        const {
          onTagRemoved,
          onTagsChanged
        } = this.props;
        const {
          tagOptions,
          selectedTags
        } = this.state;
        const newSelectedTags = selectedTags.filter(s => s.value !== tag.value);
        this.setState({
          selectedTags: newSelectedTags,
          availTags: filterTags(tagOptions, newSelectedTags),
          // set tag's label to be placed in input box
          savedLabel: tag.label
        });
        onTagRemoved && onTagRemoved(selectedTags.find(s => s.value === tag.value));
        onTagsChanged && onTagsChanged(newSelectedTags);
      }
    });
    (0, _defineProperty2.default)(this, "_triggerNodeRenderer", ref => {
      const {
        id,
        hasValidationError,
        validationErrorText,
        successText,
        placeholder,
        disabled,
        customWidth
      } = this.props;
      const {
        showFocusClass,
        focusedInput,
        selectedTags,
        tagActionIcon,
        open
      } = this.state;
      const classes = (0, _utils.classnames)(tagInputClassName, {
        disabled,
        error: hasValidationError,
        focus: showFocusClass,
        focusedInput,
        open,
        success: successText && !hasValidationError,
        tagsSelected: selectedTags.length > 0
      });
      const inputProps = {
        autoComplete: 'off',
        'aria-labelledby': `${this._id}__required-field ${this._id}__error-message ${this._id}__success-message`,
        className: `${tagInputClassName}__input`,
        disabled,
        id,
        onBlur: this._onBlur,
        onChange: this._onInputValChange,
        onFocus: this._setInputFocused,
        onKeyDown: this._onInputKeyDown,
        placeholder: selectedTags.length === 0 ? placeholder : '',
        ref: this._inputRef,
        type: 'text',
        value: this.state.savedLabel
      };
      return (
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        _react.default.createElement("div", {
          className: classes,
          style: {
            width: customWidth
          },
          onClick: this._onFocus
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "tag-input",
          ref: node => {
            this._node = node;
            if (node) ref(node);
          }
        }, /*#__PURE__*/_react.default.createElement(_tags.default, {
          "data-tid": "ba-common-taginput__tags",
          disabled: disabled,
          ref: this._tagListRef,
          tags: selectedTags,
          tagActionIcon: tagActionIcon,
          editLabel: this._editLabel
        }, /*#__PURE__*/_react.default.createElement("input", inputProps)), /*#__PURE__*/_react.default.createElement("hr", {
          className: `${tagInputClassName}__line`
        })), hasValidationError ? /*#__PURE__*/_react.default.createElement("div", {
          className: "validation-error",
          id: `${this._id}__error-message`
        }, validationErrorText) : /*#__PURE__*/_react.default.createElement("div", {
          className: "success-message",
          id: `${this._id}__success-message`
        }, successText))
      );
    });
    (0, _defineProperty2.default)(this, "_inputRef", node => {
      this.inputNode = node;
    });
    (0, _defineProperty2.default)(this, "_tagListRef", node => {
      this._tagList = node;
    });
    (0, _defineProperty2.default)(this, "_dropdownRef", node => {
      this._dropdown = node;
    });
    const _tagActionIcon = {
      id: _close_.default.id,
      onClick: this._deleteTag.bind(this)
    };
    this.state = {
      availTags: typeof this.props.selectedTags !== 'undefined' ? filterTags(this.props.tagOptions, this.props.selectedTags) : this.props.tagOptions,
      open: false,
      selectedTags: this.props.selectedTags,
      showFocusClass: false,
      tagActionIcon: _tagActionIcon,
      tagOptions: this.props.tagOptions,
      savedLabel: this.props.value
    };
    this._id = uniqueId('__tagInput_');
    this._editLabel = this._editLabel.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this._close);
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      // If the value prop changed, update the internal state.
      this._updateState(true, this.props.value);
    } else if (JSON.stringify(this.props.tagOptions) !== JSON.stringify(prevProps.tagOptions) || JSON.stringify(this.props.selectedTags) !== JSON.stringify(prevProps.selectedTags)) {
      // This way of comparing JavaScript arrays is not ideal, but does the job here.
      // A more comprehensive and elegant way would be to *recursively* compare each element by value.
      this._updateState(true);
    } // Max height of tagInput should be 96px as designed.


    if (this._tagList && this._tagList._list.offsetHeight > 96) {
      this._tagList._node.scrollTop = this._tagList._node.scrollHeight - this._tagList._node.clientHeight;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._close);
  }

  blur() {
    this.inputNode && this.inputNode.blur();
  }

  focus() {
    !this.props.disabled && this.inputNode && this.inputNode.focus();
  }

  _refreshOptions(tagOptions, selectedTags) {
    return filterTags(tagOptions, selectedTags);
  }

  _deleteTag(e, currentTag) {
    const {
      onTagRemoved,
      onTagsChanged
    } = this.props;
    const {
      tagOptions,
      selectedTags
    } = this.state;
    const id = currentTag.value;
    const newSelectedTags = selectedTags.filter(tag => tag.value !== id);
    this.setState({
      selectedTags: newSelectedTags,
      availTags: filterTags(tagOptions, newSelectedTags)
    });
    onTagRemoved && onTagRemoved(selectedTags.find(tag => tag.value === id));
    onTagsChanged && onTagsChanged(newSelectedTags);
  }

  render() {
    const {
      className,
      customWidth,
      size,
      ...others
    } = this.props;
    const {
      availTags,
      focusIndex,
      open
    } = this.state;
    const listDropdownPassthroughProps = getInheritedProps(others, _listdropdown.default);
    const dropdownProps = { ...sanitize(others, TagInput),
      ...listDropdownPassthroughProps,
      customWidth,
      focusIndex,
      onActiveChange: this._dropdownOnActiveChange,
      onChange: this._onTagSelect,
      onClose: this._onClose,
      onScrollClose: this._onClose,
      open,
      options: availTags,
      ref: this._dropdownRef,
      size,
      triggerNodeRenderer: this._triggerNodeRenderer,
      truncated: true
    };
    return /*#__PURE__*/_react.default.createElement(_listdropdown.default, (0, _extends2.default)({
      className: className,
      "data-tid": "ba-common-tag-input__dropdown"
    }, dropdownProps));
  }

}

exports.default = TagInput;
(0, _defineProperty2.default)(TagInput, "propTypes", { ...sanitize(_listdropdown.default.propTypes, null, 'triggerNodeRenderer', 'options'),

  /** Classname to be given to the container of TagInput */
  className: _propTypes.default.string,

  /** Value of the input field */
  value: _propTypes.default.string,

  /** Custom filtering function */
  customFilter: _propTypes.default.func,

  /** Custom function to control the open state of the dropdown */
  customOpenStateController: _propTypes.default.func,

  /** Width set */
  customWidth: _propTypes.default.string,

  /** Disable tag input */
  disabled: _propTypes.default.bool,

  /** To show validation error state */
  hasValidationError: _propTypes.default.bool,

  /** ID for input of TagInput */
  id: _propTypes.default.string,

  /** Function that is called when a tag is added and return the added tag */
  onTagAdded: _propTypes.default.func,

  /** Function that is called when value is typed into input field */
  onChange: _propTypes.default.func,

  /** Function that is called when a tag is removed and return the removed tag */
  onTagRemoved: _propTypes.default.func,

  /** Function that is called when a selected tag array is changed and return the selected tags array */
  onTagsChanged: _propTypes.default.func,

  /** Placeholder text */
  placeholder: _propTypes.default.string,

  /** Choose between one of the two fixed sizes */
  size: _propTypes.default.oneOf(['normal', 'small']),

  /** To show validation success message */
  successText: _propTypes.default.string,

  /** Selected tags to show in the input box, with designated colors for preset */
  selectedTags: _propTypes.default.array,

  /** Number key is for the maximum number of tags a user can select and onWarning is a callback function when a user tries to go over the limit. */
  selectionCap: _propTypes.default.object,

  /** Tag options where a user select tags from, , with designated colors for preset */
  tagOptions: _propTypes.default.array,

  /** To show validation error message */
  validationErrorText: _propTypes.default.string,

  /** Accepted on the Tags control but ignored on the TagInput control because it doesn't work. */
  maxTagWidth: BaPropTypes.deprecated("is ignored because it doesn't work.")
});
(0, _defineProperty2.default)(TagInput, "defaultProps", {
  className: '',
  customWidth: '100%',
  disabled: false,
  selectedTags: [],
  size: 'normal',
  tagOptions: [],
  value: ''
});

/***/ }),

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TagInput_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(152);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TagInput_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TagInput_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TagInput_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TagInput_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[521,0]]]);
});